import type React                                        from "react";
import { createContext, useCallback, useMemo, useState } from "react";

type RoleType = { userType: string };
type AuthData = {
  role?      : RoleType | null;
  permissions: string[];
  isVerified?: boolean;
};

type AuthContextType = {
  data          : AuthData;
  setIsVerified : (isVerified?: boolean) => void;
  setRole       : (role?: RoleType | null) => void;
  setPermissions: (permissions: string[]) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children, }) => {
  const [userData, setUserData] = useState<AuthData>({ role: { userType: "" }, permissions: [] });

  const setIsVerified = useCallback((isVerified?: boolean) => {
    setUserData(prev => ({ ...prev, isVerified }));
  }, []);

  const setRole = useCallback((role?: RoleType | null) => {
    setUserData(prev => ({ ...prev, role }));
  }, []);

  const setPermissions = useCallback((permissions: string[]) => {
    setUserData(prev => ({ ...prev, permissions }));
  }, []);

  const contextValues = useMemo(() => ({
    data: userData,
    setIsVerified,
    setRole,
    setPermissions,
  }), [userData, setIsVerified, setRole, setPermissions]);

  return (
    <AuthContext.Provider value={contextValues}>
      {children}
    </AuthContext.Provider>
  );
};
